"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeal = createDeal;
exports.createDealWithAssociations = createDealWithAssociations;
exports.deleteDeal = deleteDeal;
exports.refresh = refresh;
exports.revertMove = revertMove;
exports.updateDealProperties = updateDealProperties;
exports.updateDeals = updateDeals;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _immutable = require("immutable");

var _always = _interopRequireDefault(require("transmute/always"));

var _ifElse = _interopRequireDefault(require("transmute/ifElse"));

var _q = _interopRequireDefault(require("q"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var DealsAPI = _interopRequireWildcard(require("crm_data/deals/api/DealsAPI"));

var ImmutableModel = _interopRequireWildcard(require("customer-data-objects/model/ImmutableModel"));

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var PROPS = 'properties';
var ASSOC_COMPANY_ID = 'associatedcompanyid';
var ASSOC_CONTACT_ID = 'associatedcontactid';
var emptyArray = (0, _always.default)([]);

var toIdArray = function toIdArray() {
  for (var _len = arguments.length, ids = new Array(_len), _key = 0; _key < _len; _key++) {
    ids[_key] = arguments[_key];
  }

  return ids;
};

var toId = function toId(dealRecord, prop) {
  return parseInt((0, ImmutableModel.getProperty)(dealRecord, prop), 10);
};

var toAssociatedIds = function toAssociatedIds(dealRecord, prop) {
  return (0, _ifElse.default)(isNaN, emptyArray, toIdArray, toId(dealRecord, prop));
};

var toProperties = function toProperties(dealRecord) {
  return dealRecord.get(PROPS).reduce(function (list, _ref, name) {
    var value = _ref.value,
        sourceId = _ref.sourceId,
        source = _ref.source;
    if (name === ASSOC_CONTACT_ID || name === ASSOC_COMPANY_ID) return list;
    return list.push({
      value: value,
      name: name,
      sourceId: sourceId,
      source: source
    });
  }, (0, _immutable.List)());
};

var getCreateDealPayload = function getCreateDealPayload(dealRecord) {
  var portalId = _hubspot.default.get();

  var associatedCompanyIds = toAssociatedIds(dealRecord, ASSOC_COMPANY_ID);
  var associatedVids = toAssociatedIds(dealRecord, ASSOC_CONTACT_ID);

  if (dealRecord.hasIn(['associations', 'associatedVids'])) {
    associatedVids = [].concat((0, _toConsumableArray2.default)(associatedVids), (0, _toConsumableArray2.default)(dealRecord.getIn(['associations', 'associatedVids']).toJS()));
  }

  var associations = {
    associatedCompanyIds: associatedCompanyIds,
    associatedVids: associatedVids
  };
  dealRecord = dealRecord.deleteIn([PROPS, ASSOC_COMPANY_ID]).deleteIn([PROPS, ASSOC_CONTACT_ID]);
  var properties = toProperties(dealRecord);
  return (0, _immutable.fromJS)({
    properties: properties,
    portalId: portalId,
    associations: associations
  });
};

var makeAssociationKey = function makeAssociationKey(id, associationType) {
  return (0, _immutable.Map)({
    objectId: id,
    objectType: _ObjectTypes.DEAL,
    associationType: associationType
  });
};

function createDeal(dealRecord) {
  var payload = getCreateDealPayload(dealRecord);
  return DealsAPI.createDeal(payload).then(function (response) {
    var deal = response.first();
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEAL_CREATED, deal);
    setTimeout(function () {
      return (0, _Dispatch.dispatchQueue)(_ActionTypes.DEAL_PIPELINE_SEARCH_RESULT_EXPIRED, deal);
    }, 2000);
    return deal;
  });
}

function createDealWithAssociations(dealRecord, requestedAssociatedObjects) {
  var propertyValues = toProperties(dealRecord);
  return DealsAPI.createDealWithAssociations({
    propertyValues: propertyValues,
    requestedAssociatedObjects: requestedAssociatedObjects
  }).then(function (response) {
    var deal = response.first();
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEAL_CREATED, deal);
    requestedAssociatedObjects.forEach(function (association) {
      (0, _Dispatch.dispatchQueue)(_ActionTypes.OBJECT_ASSOCIATION_SUCCEEDED, {
        objectId: association.objectId,
        associationsAdded: [ImmutableModel.getId(deal)],
        fromObjectType: association.objectType,
        toObjectType: _ObjectTypes.DEAL
      });
    });
    setTimeout(function () {
      return (0, _Dispatch.dispatchQueue)(_ActionTypes.DEAL_PIPELINE_SEARCH_RESULT_EXPIRED, deal);
    }, 2000);
    return deal;
  });
}

function deleteDeal(dealId, callback) {
  return DealsAPI.deleteDeal(dealId).then(function () {
    setTimeout(function () {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEALS_UPDATED, (0, _immutable.Map)().set("" + dealId, null));
    }, 0);
    return typeof callback === 'function' ? callback() : undefined;
  }).done();
}

function refresh(ids) {
  (0, _Dispatch.dispatchQueue)(_ActionTypes.DEALS_REFRESH_QUEUED, (0, _immutable.Set)(ids));
  (0, _Dispatch.dispatchQueue)(_ActionTypes.ASSOCIATIONS_REFRESH_QUEUED, (0, _immutable.Set)([makeAssociationKey(ids[0], _AssociationTypes.DEAL_TO_COMPANY), makeAssociationKey(ids[0], _AssociationTypes.DEAL_TO_CONTACT), makeAssociationKey(ids[0], _AssociationTypes.DEAL_TO_LINE_ITEM), makeAssociationKey(ids[0], _AssociationTypes.DEAL_TO_QUOTE), makeAssociationKey(ids[0], _AssociationTypes.DEAL_TO_TICKET)]));
}

function revertMove(dealId) {
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.REVERT_DEAL_STAGE_MOVE, dealId);
}

function updateDealProperties(deal, nextProperties, options) {
  if (options == null) {
    options = {};
  }

  var id = "" + (0, ImmutableModel.getId)(deal);
  var pipeline = (0, ImmutableModel.getProperty)(deal, 'pipeline');
  var properties = nextProperties.map(function (_, name) {
    return (0, ImmutableModel.getProperty)(deal, name);
  });

  if (nextProperties.has('dealstage') && !options.updatedValues) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEAL_STAGE_CHANGE, {
      id: id,
      pipeline: pipeline,
      nextProperties: nextProperties,
      prevProperties: properties,
      options: options
    });
    return _q.default.Promise.resolve();
  }

  (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEALS_UPDATE_STARTED, {
    id: id,
    nextProperties: nextProperties,
    properties: properties
  });
  return DealsAPI.updateDealProperties(deal, nextProperties).then(function (updatedDeal) {
    return (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEALS_UPDATE_SUCCEEDED, {
      id: id,
      prevProperties: properties,
      properties: nextProperties,
      deal: updatedDeal
    });
  }, function (error) {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEALS_UPDATE_FAILED, {
      error: error,
      id: id,
      nextProperties: nextProperties,
      properties: properties
    });
    throw error;
  });
}

function updateDeals(deals) {
  (0, _invariant.default)(_immutable.Map.isMap(deals), 'DealsActions: expected deals to be a Map but got `%s`', deals);
  return (0, _Dispatch.dispatchImmediate)(_ActionTypes.DEALS_UPDATED, deals);
}